import TranslatedEnum from './TranslatedEnum.js'

export default class ModuleEnum extends TranslatedEnum {
  static get KEYS() {
    return {
      CITES_EXPORT: 'CITES_EXPORT',
      CITES_IMPORT: 'CITES_IMPORT',
      IUU: 'IUU',
      EDAV_INPEC: 'EDAV_INPEC',
      EDAV_TRACES: 'EDAV_TRACES',
      EDAV_WHITELIST: 'EDAV_WHITELIST',
      PHYTO: 'PHYTO'
    }
  }

  static get ADDITIONAL_KEYS() {
    return {
      EDAV: 'EDAV',
      INPEC: 'INPEC',
      TRACES: 'TRACES',
      WHITELIST: 'WHITELIST'
    }
  }

  static get I18N() {
    return {
      de: {
        CITES_EXPORT: 'CITES Export',
        CITES_IMPORT: 'CITES Import',
        IUU: 'IUU',
        EDAV_INPEC: 'EDAV & NTLM - INPEC',
        EDAV_TRACES: 'EDAV & NTLM - TRACES',
        EDAV_WHITELIST: 'EDAV & NTLM - Paket Privat',
        PHYTO: 'PHYTO',

        EDAV: 'EDAV & NTLM',
        INPEC: 'INPEC',
        TRACES: 'TRACES',
        WHITELIST: 'Paket Privat'
      },
      fr: {
        CITES_EXPORT: 'Exportation CITES',
        CITES_IMPORT: 'Importation CITES',
        IUU: 'INN',
        EDAV_INPEC: 'OITE & DAOVeg - INPEC',
        EDAV_TRACES: 'OITE & DAOVeg - TRACES',
        EDAV_WHITELIST: 'OITE & DAOVeg - Paquet particulier',
        PHYTO: 'PHYTO',

        EDAV: 'OITE & DAOVeg',
        INPEC: 'INPEC',
        TRACES: 'TRACES',
        WHITELIST: 'Paquet particulier'
      },
      it: {
        CITES_EXPORT: 'Esportazione CITES',
        CITES_IMPORT: 'Importazione CITES',
        IUU: 'INN',
        EDAV_INPEC: 'OITE & DAOVeg - INPEC',
        EDAV_TRACES: 'OITE & DAOVeg - TRACES',
        EDAV_WHITELIST: 'OITE & DAOVeg - Pacchetto privato',
        PHYTO: 'PHYTO',

        EDAV: 'OITE & DAOVeg',
        INPEC: 'INPEC',
        TRACES: 'TRACES',
        WHITELIST: 'Pacchetto privato'
      }
    }
  }

  static EDAV_ITEMS() {
    return this.formatItems([
      ModuleEnum.KEYS.EDAV_INPEC,
      ModuleEnum.KEYS.EDAV_TRACES,
      ModuleEnum.KEYS.EDAV_WHITELIST
    ])
  }
}
